import { render, staticRenderFns } from "./c-edit-group-popup.vue?vue&type=template&id=b868b3a0"
import script from "./c-edit-group-popup.vue?vue&type=script&lang=js"
export * from "./c-edit-group-popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b868b3a0')) {
      api.createRecord('b868b3a0', component.options)
    } else {
      api.reload('b868b3a0', component.options)
    }
    module.hot.accept("./c-edit-group-popup.vue?vue&type=template&id=b868b3a0", function () {
      api.rerender('b868b3a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/mconfigs/views/pre-release/popups/c-edit-group-popup.vue"
export default component.exports